export const GEO_BY_IP_FETCH_ERROR = 'Ошибка при получении гео по IP:';
